import cn from "classnames";

import css from "./styles.module.scss";

const checkOrientation = (image) => {
	if (image) {
		const img = new Image();
		img.src = image;
		if (img.width > img.height) {
			return "horizontal";
		}
		return "vertical";
	}
};

export const ImageOverlay = ({ image, isImageVisible, setIsImageVisible }) => {
	return (
		<>
			<button
				className={cn(css.imageOverlay, { [css.visible]: isImageVisible })}
				onClick={() => {
					setIsImageVisible(false);
				}}
			/>
			<div
				className={cn(css.absoluteImageContainer, {
					[css.show]: isImageVisible,
					[css.hide]: isImageVisible === false,
				})}
			>
				<img
					src={image}
					alt=""
					className={cn({
						[css.verticalImage]: checkOrientation(image) === "vertical",
						[css.horizontalImage]: checkOrientation(image) === "horizontal",
					})}
				/>
			</div>
		</>
	);
};
